<template>
  <div>
    <div id="payment-form">
      <!-- <p>send recipt for this email</p> -->
      <!-- <input v-model="email" id="email" type="email"> -->
      <div id="card-element"><!--Stripe.js injects the Card Element--></div>
      <button id="submit" @click="payWithCard">
        <div class="spinner hidden" id="spinner"></div>
        <span id="button-text">Pay</span>
      </button>
      <p v-if="errMsg" id="card-errors" role="alert">{{errMsg}}</p>
      <p class="result-message hidden">
        Payment succeeded!
      </p>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'StripePayment',

  props: [
    'item',
    'request',
    'api',
  ],

  data() {
    return {
      stripe: Stripe(process.env.NODE_ENV === 'production' ? process.env.VUE_APP_STRIPE_KEY : process.env.VUE_APP_STRIPE_KEY_TEST),
      cardData: {},
      token: '',
      errMsg: '',
      email: '',
      paymentData: {},
      trade: '',
    }
  },

  created() {
    this.createPayment()
    this.email = this.$store.state.account.email
  },

  methods: {

    complete() {
      this.$emit('complete')
    },

    createPayment() {

      axios.get(`private/payment/client?${this.api}_id=${this.request.id}`)
      .then(data => {
        this.paymentData = data.data.payment
        this.token = data.data.payment.token
        let elements = this.stripe.elements()
        let style = {
          base: {
            color: "#32325d",
            fontFamily: 'Arial, sans-serif',
            fontSmoothing: "antialiased",
            fontSize: "16px",
            "::placeholder": {
              color: "#32325d"
            }
          },
          invalid: {
            fontFamily: 'Arial, sans-serif',
            color: "#fa755a",
            iconColor: "#fa755a"
          }
        }

        this.cardData = elements.create("card", { style: style });
        // Stripe injects an iframe into the DOM
        this.cardData.mount("#card-element");
        this.cardData.on("change", function (event) {
          // Disable the Pay button if there are no card details in the Element
          document.querySelector("button").disabled = event.empty;
          // document.querySelector("#card-errors").textContent = event.error ? event.error.message : "";
        });
        var form = document.getElementById("payment-form");

      }).catch(err => {
        console.log(err)
      })
    },


    payWithCard() {
      this.paymentLoading(true)
      this.stripe.confirmCardPayment(this.token, {
        payment_method: {
          card: this.cardData
        }
      })
      .then(result => {
        if (result.error) {
          // Show error to your customer
          this.paymentLoading(false)
          this.errMsg = result.error.message
        } else {
          this.registCharge()
        }
      });
    },

    // Show a spinner on payment submission
    paymentLoading(isLoading) {
      if (isLoading) {
        // Disable the button and show a spinner
        document.querySelector("button").disabled = true;
        document.querySelector("#spinner").classList.remove("hidden");
        document.querySelector("#button-text").classList.add("hidden");
      } else {
        document.querySelector("button").disabled = false;
        document.querySelector("#spinner").classList.add("hidden");
        document.querySelector("#button-text").classList.remove("hidden");
      }
    },

    requestDone(id) {
      axios.put(`/private/request/done/${id}`, {is_done: 1})
      .then(data => {
        this.orderComplete()
      }).catch(err => {
        console.log(err)
      })
    },

    itemDone(id) {
      axios.put(`/private/item/done/${id}`, {is_done: 1})
      .then(data => {
        this.orderComplete()
      }).catch(err => {
        console.log(err)
      })
    },

    registCharge() {
      axios.get(`private/stripe/intent/${this.paymentData.intent_id}`).then(data => {
        axios.put('private/payment/charge_id', {
          id: this.paymentData.id,
          charge_id: data.data.data.charges.data[0].id
        }).then(chargeData => {
          this.updateTrade()
        }).catch(err => {
          console.log(err)
          this.$parent.noticeType = 'erorr'
          this.$parent.noticeTitle = 'payment was faild!'
          this.$parent.isNotice = true
          this.$parent.loading = false
          this.$parent.isStripeModal = false
        })
      }).catch(err => {
        console.log(err)
        this.$parent.noticeType = 'erorr'
        this.$parent.noticeTitle = 'payment was faild!'
        this.$parent.isNotice = true
        this.$parent.loading = false
        this.$parent.isStripeModal = false
      })
    },

    updateTrade() {
      const postData = {
        buyer_id: this.$store.state.account.id,
        request_id: this.paymentData.request_id,
        idea_id: this.paymentData.idea_id,
        item_id: this.paymentData.item_id,
        saler_id: this.paymentData.saler_id,
        type: this.api === 'request'? 0 : 1,
      };
      if(this.api === 'request') {
        axios.post('private/trade/payment_done', postData)
        .then((data) => {
          this.requestDone(this.paymentData.request_id)
        }).catch((err) => {
          console.log(err)
          this.$parent.noticeType = 'erorr'
          this.$parent.noticeTitle = 'payment was faild!'
          this.$parent.isNotice = true
          this.$parent.loading = false
          this.$parent.isStripeModal = false
        })
      } else  {
        axios.post('private/trade/purchase_item', postData)
        .then((data) => {
          this.itemDone(this.paymentData.item_id)
        }).catch((err) => {
          console.log(err)
          this.$parent.noticeType = 'erorr'
          this.$parent.noticeTitle = 'payment was faild!'
          this.$parent.isNotice = true
          this.$parent.loading = false
          this.$parent.isStripeModal = false
        })
      }
    },

    orderComplete(paymentIntentId) {
      this.paymentLoading(false)
      document.querySelector(".result-message").classList.remove("hidden")
      document.querySelector("button").disabled = true
      this.complete()
    },
  }
}

</script>

<style scoped>

/* Variables */
* {
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 16px;
  -webkit-font-smoothing: antialiased;
  display: flex;
  justify-content: center;
  align-content: center;
  height: 100vh;
  width: 100vw;
}

form {
  width: 30vw;
  align-self: center;
  box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),
    0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);
  border-radius: 7px;
}

input {
  border-radius: 6px;
  margin-bottom: 6px;
  padding: 12px;
  border: 1px solid rgba(50, 50, 93, 0.1);
  height: 44px;
  font-size: 16px;
  width: 100%;
  background: white;
}

.result-message {
  line-height: 22px;
  font-size: 16px;
}

.result-message a {
  color: rgb(89, 111, 214);
  font-weight: 600;
  text-decoration: none;
}

.hidden {
  display: none;
}

.card-error {
  color: rgb(105, 115, 134);
  text-align: left;
  font-size: 13px;
  line-height: 17px;
  margin-top: 12px;
}

#card-element {
  border-radius: 4px 4px 0 0 ;
  padding: 12px;
  border: 1px solid rgba(50, 50, 93, 0.1);
  height: 44px;
  width: 100%;
  background: white;
}

#payment-request-button {
  margin-bottom: 32px;
}

/* Buttons and links */
button {
  background: #5469d4;
  color: #ffffff;
  font-family: Arial, sans-serif;
  border-radius: 0 0 4px 4px;
  border: 0;
  padding: 12px 16px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: block;
  transition: all 0.2s ease;
  box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.07);
  width: 100%;
}

button:hover {
  filter: contrast(115%);
}

button:disabled {
  opacity: 0.5;
  cursor: default;
}

/* spinner/processing state, errors */
.spinner,
.spinner:before,
.spinner:after {
  border-radius: 50%;
}

.spinner {
  color: #ffffff;
  font-size: 22px;
  text-indent: -99999px;
  margin: 0px auto;
  position: relative;
  width: 20px;
  height: 20px;
  box-shadow: inset 0 0 0 2px;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}

.spinner:before,
.spinner:after {
  position: absolute;
  content: "";
}

.spinner:before {
  width: 10.4px;
  height: 20.4px;
  background: #5469d4;
  border-radius: 20.4px 0 0 20.4px;
  top: -0.2px;
  left: -0.2px;
  -webkit-transform-origin: 10.4px 10.2px;
  transform-origin: 10.4px 10.2px;
  -webkit-animation: loading 2s infinite ease 1.5s;
  animation: loading 2s infinite ease 1.5s;
}

.spinner:after {
  width: 10.4px;
  height: 10.2px;
  background: #5469d4;
  border-radius: 0 10.2px 10.2px 0;
  top: -0.1px;
  left: 10.2px;
  -webkit-transform-origin: 0px 10.2px;
  transform-origin: 0px 10.2px;
  -webkit-animation: loading 2s infinite ease;
  animation: loading 2s infinite ease;
}

@-webkit-keyframes loading {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loading {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@media only screen and (max-width: 600px) {
  form {
    width: 80vw;
  }
}
</style>
